import { detectEncryptedContent, isJencPath } from './editorEncryption';

export type JencLockKind = 'none' | 'existing' | 'new';
export type JencEditorLoadState = 'idle' | 'loading' | 'loaded' | 'error' | 'locked';

/** How a loaded editor payload should treat .jenc / JARVIS-ENC content. */
export function resolveJencLockKind(path: string, content: string): JencLockKind {
  if (!isJencPath(path) && !detectEncryptedContent(content)) return 'none';
  return detectEncryptedContent(content) ? 'existing' : 'new';
}

/**
 * DevExtreme Popup fires `onHiding` when `visible` becomes false after a
 * successful unlock. Only treat hide as a user cancel while the dialog is
 * still supposed to be open.
 */
export function shouldTreatUnlockDialogHidingAsCancel(dialogVisible: boolean): boolean {
  return dialogVisible;
}

/**
 * Closing the unlock dialog must never replace a successful load with the
 * "unlock was cancelled" error. Stay locked so Unlock can reopen the dialog.
 */
export function resolveUnlockCancelLoadState(current: JencEditorLoadState): JencEditorLoadState {
  if (current === 'loaded') return 'loaded';
  if (current === 'idle' || current === 'loading' || current === 'error') return current;
  return 'locked';
}
